import { z } from 'zod';

export const phonePattern = /^[+]?[\d\s().-]{7,25}$/;

export const contactSchema = z.object({
  name: z.string().trim().min(2, { message: 'name' }),
  email: z.string().trim().email({ message: 'email' }),
  phone: z
    .string()
    .trim()
    .refine((value) => value.length === 0 || phonePattern.test(value), { message: 'phone' }),
  text: z
    .string()
    .trim()
    .min(40, { message: 'textMin' })
    .max(5000, { message: 'textMax' }),
  companyWebsite: z.string().optional(),
});

export type ContactFormValues = z.infer<typeof contactSchema>;
